import React from 'react';
import { Box, Container, Divider, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import TwoFactorSettings from '../components/security/TwoFactorSettings';

export const TRANSCRIBER_SECURITY_PATH = '/transcriber/security';
export const QUALITY_CONTROLLER_SECURITY_PATH = '/quality-controller/security';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 110,
    marginBottom: 40,
  },
  title: {
    fontSize: '1.75rem',
    marginBottom: theme.spacing(4),
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 8,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2),
    },
  },
  description: {
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
}));

function SecurityPage({ history, location }) {
  const classes = useStyles();
  const [t] = useTranslation();
  // The page lives next to the dashboard of the freelancer's role
  const dashboardPath = location.pathname.replace(/security$/, 'dashboard');

  return (
    <Container maxWidth="md" className={classes.container}>
      <Typography variant="h4" component="h1" className={classes.title}>
        {t('security.title')}
      </Typography>
      <Paper className={classes.card} elevation={2}>
        <Typography variant="h6" component="h2">
          {t('security.twoFactorTitle')}
        </Typography>
        <Box marginTop={1}>
          <Typography variant="body2" className={classes.description}>
            {t('security.twoFactorDescription')}
          </Typography>
        </Box>
        <Divider className={classes.divider} />
        <TwoFactorSettings onDone={() => history.push(dashboardPath)} />
      </Paper>
    </Container>
  );
}

SecurityPage.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
};

export default SecurityPage;
